export const USER_TYPES = {
    COMMON_FOLK: { type: "commonfolk", string: "Common Folk" },
    MESSAGER: { type: "messager", string: "Messager" },
};
